<template>
  <el-dialog
    :visible.sync="isVisible"
    custom-class="modal"
    title="Please enter the 6-digit code received by SMS."
    center
  >
    <div v-if="loading" class="modal-loading">
      <span
        class="modal-loader"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      />
    </div>
    <el-form
      :model="form"
      label-position="left"
      label-width="0px"
      :inline="true"
    >
      <code-input v-model="form.code" />
    </el-form>
    <p v-if="codeFromResponse" class="modal-tip">
      Write this code below: {{ codeFromResponse }}
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Cancel</el-button>
      <el-button type="primary" @click="validateCode">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Auth } from '@/api'
import CodeInput from './CodeInput.vue'

export default {
  components: {
    CodeInput
  },
  data() {
    return {
      loading: false,
      codeFromResponse: '',
      isVisible: false,
      form: {
        challenge_id: undefined,
        code: ''
      }
    }
  },
  methods: {
    openModal(responseData) {
      this.isVisible = true
      this.form = {
        challenge_id: responseData.challenge_id,
        code: ''
      }
      this.codeFromResponse = responseData.code || undefined
    },
    closeModal() {
      this.isVisible = false
      this.form = {
        challenge_id: undefined,
        code: ''
      }
    },
    redirectOnSuccess() {
      this.$router.push(this.$route.query.next || '/dashboard/')
    },
    validateCode() {
      if (this.loading) return
      this.loading = true

      Auth.codeVerification({
        challenge_id: this.form.challenge_id,
        code: this.form.code
      })
        .then(response => {
          window.localStorage.setItem('token', 'Token ' + response.data.key)
          this.redirectOnSuccess()
        })
        .catch(error => {
          let message = 'An error occurred while logging in.'
          const response = error && error.response
          const responseStatus = response && response.status
          const nonFieldErrors =
            response && response.data && response.data.non_field_errors

          if (responseStatus === 429) {
            message = 'Too many attempts. Please try again later.'
          } else if (nonFieldErrors) {
            message = `${message} ${nonFieldErrors}`
          }

          this.$message({
            message: message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .modal {
  margin: 0 auto !important;
  top: 50%;
  transform: translate(0, -50%);
}
.modal-tip {
  margin-top: 20px;
}
.modal-loading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-loader {
  width: 100%;
  height: 100%;
}
</style>
